export default {
      id: "about-symbols-10-usage",
      viewBox: "0 0 150 150",
      url: "/" + "sprite.svg#about-symbols-10",
      toString: function () {
        return this.url;
      }
    }